import { render } from "./MonthView.vue?vue&type=template&id=0c970d36&scoped=true"
import script from "./MonthView.vue?vue&type=script&lang=js"
export * from "./MonthView.vue?vue&type=script&lang=js"

import "./MonthView.vue?vue&type=style&index=0&id=0c970d36&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c970d36"]])

export default __exports__